import { render } from "./EditOrderModal.vue?vue&type=template&id=4ba6e57a"
import script from "./EditOrderModal.vue?vue&type=script&lang=js"
export * from "./EditOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__